import {
    FETCH_CONTACT,
    FETCH_CONTACTS,
    FETCH_CTTGROUPS,
    FETCH_CTTGPS,
} from '../actions/contact';


export const initialState = {
    isFetching: true,
    data: null
};

export const contacts = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CONTACTS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CONTACTS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const cttgps = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CTTGPS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CTTGPS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const contact = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CONTACT}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CONTACT}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const cttgroups = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CTTGROUPS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CTTGROUPS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/contact.js